/**
 * Keepalive de sesión POS y refresco al volver a la pestaña.
 */

const KEEPALIVE_INTERVAL_MS = 5 * 60 * 1000;

export function initSessionKeepalive(win, $) {
	if (win._posknKeepaliveBound) return;
	win._posknKeepaliveBound = true;

	win.posSesionExpirada = function posSesionExpirada() {
		if (typeof win.mostrarNotificacion === 'function') {
			win.mostrarNotificacion(
				'Sesión expirada. Recarga la página para seguir usando el POS.',
				'error',
			);
		} else {
			win.alert('Sesión expirada. Recarga la página para seguir usando el POS.');
		}
	};

	win.posKeepaliveSilent = function posKeepaliveSilent() {
		const cfg = win.POSKN_API_CONFIG || {};
		const url = cfg.ajaxUrl || 'pos-ajax.php';
		const nonce = win.posNonce || cfg.posNonce || '';
		$.ajax({
			url,
			method: 'POST',
			data: { action: 'pos_keepalive', nonce, _t: Date.now() },
			dataType: 'json',
			timeout: 10000,
			success(res) {
				if (typeof win.posknApplyServerReachable === 'function') {
					win.posknApplyServerReachable(true);
				} else {
					win.posknServerReachable = true;
					win._posknOfflineOrderMode = false;
					if (typeof win.posknUpdateConnectionStatus === 'function') {
						win.posknUpdateConnectionStatus();
					}
				}
				if (res && !res.success && res.data === 'Sesión expirada') {
					win.posSesionExpirada();
				}
			},
			error(xhr) {
				if (xhr.status === 401) {
					win.posSesionExpirada();
					return;
				}
				// No marcar offline aquí: una petición colgada al volver la red
				// dejaba el POS en “sin servidor” aunque ya hubiera internet.
				if (!xhr.status || xhr.status === 0 || xhr.status >= 500) {
					if (typeof win.posknProbeServer === 'function') {
						win.posknProbeServer(true);
					}
				}
			},
		});
	};

	$(() => {
		win.setInterval(win.posKeepaliveSilent, KEEPALIVE_INTERVAL_MS);
		win.setTimeout(win.posKeepaliveSilent, 60000);

		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState !== 'visible') return;
			if (
				typeof win.getColaPendientesSubir === 'function' &&
				win.getColaPendientesSubir().length > 0 &&
				typeof win.procesarColaSubida === 'function'
			) {
				win.procesarColaSubida();
			}
			win.posKeepaliveSilent();
		});
	});
}
